import { StageScheduleValidationError } from '~/models';
export const scheduleErrorMessage = (error, texts)=>{
    switch(error){
        case StageScheduleValidationError.SetDate:
            return texts.errors.setDate();
        case StageScheduleValidationError.DateBeforeEffectiveDate:
            return texts.errors.dateBeforeEffectiveDate();
        case StageScheduleValidationError.DaysRequired:
            return texts.errors.daysRequired();
        case StageScheduleValidationError.DaysAtLeastOne:
            return texts.errors.daysAtLeastOne();
    }
};
